import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserKYCCreateRequestDTO, UserKYCDeleteRequestDTO, UserKYCDTO, UserKYCList, UserKYCReadByIdRequestDTO, UserKYCReadByUserIdRequestDTO, UserKYCUpdateRequestDTO } from './userkyc.interface';
import { UserKYC_Create, UserKYC_Delete, UserKYC_ReadAll, UserKYC_ReadById, UserKYC_ReadByUserId, UserKYC_Update } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class UserKYCService {
  private http = inject(HttpClient);

  UserKYC_Create(data: UserKYCCreateRequestDTO): Observable<UserKYCDTO> {
    return this.http.post<UserKYCDTO>(UserKYC_Create, data);
  }

  UserKYC_Delete(data: UserKYCDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(UserKYC_Delete, data);
  }

  UserKYC_ReadAll(): Observable<UserKYCList> {
    return this.http.get<UserKYCList>(UserKYC_ReadAll);
  }

  UserKYC_ReadById(data: UserKYCReadByIdRequestDTO): Observable<UserKYCDTO> {
    return this.http.post<UserKYCDTO>(UserKYC_ReadById, data);
  }

  UserKYC_ReadByUserId(data: UserKYCReadByUserIdRequestDTO): Observable<UserKYCDTO> {
    return this.http.post<UserKYCDTO>(UserKYC_ReadByUserId, data);
  }

  UserKYC_Update(data: UserKYCUpdateRequestDTO): Observable<UserKYCDTO> {
    return this.http.post<UserKYCDTO>(UserKYC_Update, data);
  }
}
